import { apiRequest } from 'utils/request'
import { normalizeFeature } from 'schemas/feature'

export const normalizeAndRepackFeature = (response) => {
  const { data } = response
  return { data: { feature: normalizeFeature(data) } }
}

export const create = async ({ feature }) => {
  const response = await apiRequest({
    uri: '/features/create',
    method: 'POST',
    body: feature,
  })
  return normalizeAndRepackFeature(response)
}

export const update = async ({ feature }) => {
  const response = await apiRequest({
    uri: `/features/${feature.id}/update`,
    method: 'POST',
    body: feature,
  })
  return normalizeAndRepackFeature(response)
}

export const duplicate = async ({ id }) => {
  const response = await apiRequest({
    uri: `/features/${id}/duplicate`,
    method: 'POST',
  })
  return normalizeAndRepackFeature(response)
}

export const get = async ({ featureId }) => {
  const response = await apiRequest({
    uri: `/features/${featureId}`,
  })
  return normalizeAndRepackFeature(response)
}

export const validateDynamicContent = async ({ payload, serialNumber }) => {
  const response = await apiRequest({
    uri: `/vehicles/${serialNumber}/features/validate/dynamic-content`,
    method: 'POST',
    body: payload,
  })
  return response
}

export const createFeatureRevision = async ({ featureId }) => {
  const response = await apiRequest({
    uri: `/features/${featureId}/create-revision`,
    method: 'POST',
  })
  return normalizeAndRepackFeature(response)
}
